export default __webpack_public_path__ + "static/media/ET1.378ae8fd.png";